<ion-button
  (click)="openLanguageMenu($event)"
  [matTooltip]="'m/task-process/tooltips/spellchecker-lang' | translate"
  size="small"
  fill="clear">
  <div [class]="spellChecker?.currentLanguage.cssClass"></div>
</ion-button>
